<template lang="pug">
  header.header
    router-link(to="/", v-on:click.native="clearExpand")
      img.logo(src="../assets/img/ppr-horiz-200.svg", alt="Progressive Plant Research", draggable="false")
    a#skip(href="#main") Skip to Main Content
    button.hamburger.hamburger--spin(v-on:click="classToggle", aria-label="Menu", aria-controls="navigation", aria-haspopup="true", aria-expanded="false")
      .hamburger-box
        .hamburger-inner
    nav#nav
      router-link(v-for="(link, index) in settings.header_links", :key="index", :to="link.header_link_route", v-on:click.native="clearExpand") {{ link.header_link_text }}
</template>

<script>
export default {
  props: ['settingsData'],
  computed: {
    settings: function () {
      return this.settingsData
    }
  },
  methods: {
    classToggle: function () {
      document.querySelector('body').classList.toggle('expanded')
      document.querySelector('.hamburger').classList.toggle('is-active')
      let expanded = document.querySelector('.hamburger').getAttribute('aria-expanded')
      if (expanded === 'true') {
        document.querySelector('.hamburger').setAttribute('aria-expanded', 'false')
      } else {
        document.querySelector('.hamburger').setAttribute('aria-expanded', 'true')
      }
    },
    clearExpand: function () {
      document.querySelector('body').classList.remove('expanded');
      document.querySelector('.hamburger').classList.remove('is-active');
      document.querySelector('.hamburger').setAttribute('aria-expanded', 'false');
    }
  }
}
</script>

<style lang="stylus">
@import '../styles/helpers/variables.styl'
@import '../styles/helpers/mixins.styl'
@import '../styles/components/hamburger.styl'

.header
  background-color $green-tint
  align-items center
  display flex
  justify-content space-around
  position fixed
  top 0
  width 100%
  z-index 100000
  nav
    display grid
    grid-template-columns 1fr 1fr 1fr
    grid-gap 20px
    align-self center
    a
      color $white
      padding-bottom 0.5rem
      position relative
      text-decoration none
      &:first-child
        margin-right 1.5rem
      &:before
        background-color $white
        bottom 0
        content ""
        height 1px
        left 0
        position absolute
        transform scaleX(0)
        transition all 0.32s ease-out 0s
        visibility hidden
        width 100%
      &:hover
        &:before
          transform scaleX(1)
          visibility visible
      &.router-link-active
        font-weight bold
  .logo
    height 100px
    max-width 250px
  .hamburger
    display none
  #skip
    background-color $green
    border-radius 0.5rem
    color $white
    left -10000px
    padding 1rem 1rem
    position absolute
    text-decoration none
    &:focus
      left 0
      position static
    &:hover
      background-color $white
      color $green
      cursor pointer

@media (max-width: 560px)
  .header
    align-items center
    margin-top 0
    padding-top 1.5rem
    nav
      display none
      a
        margin 0.5rem 0 0.5rem 0
        padding 1.5rem 0 1.5rem 0
    .logo
      height 100px
      max-width 200px
    .hamburger
      display inline-block
</style>
